import { Divider } from '@mui/material';
import React from 'react';
/**
 * Renders a vertical `Divider` component with optional custom styling.
 *
 * @param {object} root0 - Component props.
 * @param {SxProps<Theme>} [root0.sx] - Optional custom style overrides for the Divider.
 * @returns {JSX.Element} A styled vertical `Divider` component.
 */
export const TreeItemDivider = ({ sx }) => {
    return React.createElement(Divider, { flexItem: true, orientation: 'vertical', sx: [{ mt: 1, mb: 1 }, ...(Array.isArray(sx) ? sx : [sx])] });
};
